/** YYYY-MM-DD → DD.MM.YYYY für Anzeige */
export function formatDateToDDMMYYYY(ymd: string): string {
  if (!ymd || ymd.length < 10) return '';
  const [y, m, d] = ymd.slice(0, 10).split('-');
  return `${d}.${m}.${y}`;
}

/**
 * Progressive TT.MM.JJJJ input mask from digit entry.
 * e.g. "300726" → "30.07.26", "30072026" → "30.07.2026"
 */
export function formatDDMMYYYYInput(raw: string): string {
  const digits = String(raw ?? '').replace(/\D/g, '').slice(0, 8);
  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return `${digits.slice(0, 2)}.${digits.slice(2)}`;
  return `${digits.slice(0, 2)}.${digits.slice(2, 4)}.${digits.slice(4)}`;
}

/** DD.MM.YYYY (oder D.M.YYYY / TT.MM.JJ) → YYYY-MM-DD für Speicherung/API */
export function parseDDMMYYYYToYMD(input: string): string | null {
  const parts = input.trim().split(/[.\-/]/).filter(Boolean);
  if (parts.length !== 3) return null;
  const day = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10);
  let year = parseInt(parts[2], 10);
  if (Number.isNaN(day) || Number.isNaN(month) || Number.isNaN(year)) return null;
  if (year >= 0 && year <= 99) year += 2000;
  if (year < 1900 || year > 2100 || month < 1 || month > 12 || day < 1 || day > 31) return null;
  const yy = String(year);
  const mm = String(month).padStart(2, '0');
  const dd = String(day).padStart(2, '0');
  return `${yy}-${mm}-${dd}`;
}

/** Heute als YYYY-MM-DD */
export function todayYMD(): string {
  const d = new Date();
  const yy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yy}-${mm}-${dd}`;
}

/** YYYY-MM-DD + Kalendertage → YYYY-MM-DD (lokale Datumsarithmetik) */
export function addDaysYMD(ymd: string, days: number): string {
  const s = String(ymd ?? '').slice(0, 10);
  const parts = s.split('-').map((x) => parseInt(x, 10));
  if (parts.length !== 3 || parts.some((n) => Number.isNaN(n))) return todayYMD();
  const d = new Date(parts[0], parts[1] - 1, parts[2]);
  if (Number.isNaN(d.getTime())) return todayYMD();
  d.setDate(d.getDate() + Math.floor(days));
  const yy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yy}-${mm}-${dd}`;
}

/** ISO-Zeitstempel → lokales Kalenderdatum YYYY-MM-DD */
export function isoToLocalYMD(iso: string): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const yy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yy}-${mm}-${dd}`;
}

/** ISO-String → "DD.MM.YYYY, HH:mm" für Anzeige */
export function formatDateTimeDDMMYYYY(iso: string): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const datePart = isoToLocalYMD(iso);
  const timeStr = d.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit', hour12: false });
  return formatDateToDDMMYYYY(datePart) + ', ' + timeStr;
}
